import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { MdOutlineArrowBack } from "react-icons/md";
import toast from "react-hot-toast";

const QuotationDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [quotation, setQuotation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuotation = async () => {
      setLoading(true);
      // Get token from local storage
      const token = localStorage.getItem("token");

      try {
        const response = await fetch(`https://api.pegasuschauffeurdrive.com/api/quotation/${id}`, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error("Failed to fetch quotation");
        }

        const data = await response.json();
        setQuotation(data.quotation);
      } catch (error) {
        console.error("Error fetching quotation:", error);
        toast.error("Failed to fetch quotation details");
      } finally {
        setLoading(false);
      }
    };

    fetchQuotation();
  }, [id]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
        <div className="spinner-border text-light" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!quotation) {
    return (
      <div className="text-center" style={{ color: "#fff" }}>
        <h2>Quotation not found</h2>
        <Button color="primary" onClick={() => navigate("/quotations")}>
          Go Back to Quotations
        </Button>
      </div>
    );
  }

  return (
    <Container style={{ color: "#fff" }}>
      <div style={{ height: "52px" }}>
        <h1 className="fw-bold" style={{ color: "#fff" }}>
          Quotation Detail
        </h1>
      </div>
      <hr style={{ color: "#fff", borderTop: "3px solid" }} />
      
      <Row className="mb-4">
        <Col md={4}>
          <Button
            style={{
              background: "none",
              color: "#fff",
              border: "2px solid #fff",
            }}
            onClick={() => navigate("/quotations")}
          >
            <MdOutlineArrowBack /> Back
          </Button>
        </Col>
      </Row>

      <Form className="mb-5">
        <h3 className="fw-bold">Customer Information</h3>
        <hr />
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="fullName" className="fw-bold">
                Full Name
              </Label>
              <Input
                id="fullName"
                name="fullName"
                type="text"
                defaultValue={quotation.fullName}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="email" className="fw-bold">
                Email
              </Label>
              <Input
                id="email"
                name="email"
                type="text"
                defaultValue={quotation.email}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="phone" className="fw-bold">
                Phone Number
              </Label>
              <Input
                id="phone"
                name="phone"
                type="text"
                defaultValue={quotation.phone}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>

        <h3 className="mt-4 fw-bold">Journey Details</h3>
        <hr />
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="pickUpLocation" className="fw-bold">
                Pick Up Location
              </Label>
              <Input
                id="pickUpLocation"
                name="pickUpLocation"
                type="text"
                defaultValue={quotation.pickUpLocation}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="dropOffLocation" className="fw-bold">
                Drop Off Location
              </Label>
              <Input
                id="dropOffLocation"
                name="dropOffLocation"
                type="text"
                defaultValue={quotation.dropOffLocation}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="pickUpDate" className="fw-bold">
                Pick Up Date
              </Label>
              <Input
                id="pickUpDate"
                name="pickUpDate"
                type="text"
                defaultValue={quotation.pickUpDate}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="pickUpTime" className="fw-bold">
                Pick Up Time
              </Label>
              <Input
                id="pickUpTime"
                name="pickUpTime"
                type="text"
                defaultValue={quotation.pickUpTime}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="vehicle" className="fw-bold">
                Vehicle
              </Label>
              <Input
                id="vehicle"
                name="vehicle"
                type="text"
                defaultValue={quotation.vehicleName}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>

        <h3 className="mt-4 fw-bold">Additional Details</h3>
        <hr />
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="passenger" className="fw-bold">
                Passengers
              </Label>
              <Input
                id="passenger"
                name="passenger"
                type="text"
                defaultValue={quotation.passenger}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="luggage" className="fw-bold">
                Luggage
              </Label>
              <Input
                id="luggage"
                name="luggage"
                type="text"
                defaultValue={quotation.luggage}
                disabled={true}
              />
            </FormGroup>
          </Col>
          {quotation.message && (
            <Col md={12}>
              <FormGroup>
                <Label for="message" className="fw-bold">
                  Message
                </Label>
                <Input
                  id="message"
                  name="message"
                  type="textarea"
                  defaultValue={quotation.message}
                  disabled={true}
                  style={{ minHeight: "120px", backgroundColor: "rgba(0, 0, 0, 0.2)" }}
                />
              </FormGroup>
            </Col>
          )}
        </Row>

        <h3 className="mt-4 fw-bold">System Information</h3>
        <hr />
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="createdAt" className="fw-bold">
                Created At
              </Label>
              <Input
                id="createdAt"
                name="createdAt"
                type="text"
                defaultValue={formatDate(quotation.createdAt)}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="updatedAt" className="fw-bold">
                Last Updated
              </Label>
              <Input
                id="updatedAt"
                name="updatedAt"
                type="text"
                defaultValue={formatDate(quotation.updatedAt)}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default QuotationDetails; 